import { render, staticRenderFns } from "./UidTokenLogin.vue?vue&type=template&id=c7bca06c&scoped=true&"
import script from "./UidTokenLogin.vue?vue&type=script&lang=js&"
export * from "./UidTokenLogin.vue?vue&type=script&lang=js&"
import style0 from "./UidTokenLogin.vue?vue&type=style&index=0&id=c7bca06c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bca06c",
  null
  
)

export default component.exports